/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { Delays } from './Delays';
import type { ExtensionType } from './ExtensionType';
import type { ImpactDetails } from './ImpactDetails';

export type Impact = {
  impactOnTraffic?: Impact.impactOnTraffic;
  impactDetails?: ImpactDetails;
  delays?: Delays;
  impactExtension?: ExtensionType;
};

export namespace Impact {
  export enum impactOnTraffic {
    IMPOSSIBLE = 'IMPOSSIBLE',
    CONGESTED = 'CONGESTED',
    HEAVY = 'HEAVY',
    FREE_FLOW = 'FREE_FLOW',
    UNKNOWN = 'UNKNOWN',
  }
}
